module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    attrs: {
      "id": "header"
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.header))]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "icons"
  }, [_c('li', [_c('a', {
    staticClass: "icon fa-twitter",
    attrs: {
      "href": _vm.twitter
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("Twitter")])])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "icon fa-instagram",
    attrs: {
      "href": _vm.instagram
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("Instagram")])])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "icon fa-github",
    attrs: {
      "href": _vm.github
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("Github")])])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "icon fa-envelope-o",
    attrs: {
      "href": _vm.email
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("Email")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-51e5fcb8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppHeader.vue
// module id = 33
// module chunks = 1